// ShortcutsPopup.js
import React, { useEffect, useRef } from 'react';
import Draggable from 'react-draggable';
import './css/popup.css';
import { Translator, resources } from './Translator';

const translator = new Translator(resources);

const ShortcutsPopup = ({ onClose }) => {
    const t = (key) => translator.t(key);
    const popupRef = useRef(null);

    useEffect(() => {
        if (popupRef.current) {
            const { width, height } = popupRef.current.getBoundingClientRect();
            popupRef.current.style.setProperty('--popup-width', `${width}px`);
            popupRef.current.style.setProperty('--popup-height', `${height}px`);
        }
    }, []);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    const rows = [
        { key: 'B', desc: t('Shortcut Pen Tool') },
        { key: 'E', desc: t('Shortcut Eraser Tool') },
        { key: 'S', desc: t('Shortcut Shape Tool Toggle') },
        { key: 'L', desc: t('Shortcut Line Tool') },
        { key: 'C', desc: t('Shortcut Circle Tool') },
        { key: 'K', desc: t('Shortcut Measurement Tool') },
        { key: 'G', desc: t('Shortcut Grid Tool') },
        { key: 'A', desc: t('Shortcut Label Tool') },
        { key: 'P', desc: t('Shortcut Palette') },
        { key: 'M', desc: t('Shortcut Add Marker') },
        { key: 'D', desc: t('Shortcut 3D Terrain') },
        { key: 'Ctrl/Cmd+Z', desc: t('Shortcut Undo') },
        { key: 'Ctrl/Cmd+Y', desc: t('Shortcut Redo') },
        { key: 'Ctrl/Cmd+C', desc: t('Shortcut Copy Marker') },
        { key: 'Ctrl/Cmd+V', desc: t('Shortcut Paste Marker') },
        { key: '?', desc: t('Shortcut Show Shortcuts') },
    ];

    const keyStyle = {
        display: 'inline-block',
        minWidth: '50px',
        padding: '2px 8px',
        background: '#2c3e50',
        border: '1px solid #888',
        borderRadius: '4px',
        fontFamily: 'monospace',
        textAlign: 'center',
        fontWeight: 'bold',
        color: '#fff',
    };

    return (
        <Draggable handle=".popup-header">
            <div className="popup palette_popup" ref={popupRef} style={{ minWidth: '320px' }}>
                <div className="popup-inner">
                    <div className="popup-header">
                        <h2>{t('Keyboard Shortcuts')}</h2>
                        <span className="close_button" onClick={onClose}>&times;</span>
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '8px' }}>
                        <tbody>
                            {rows.map((r, i) => (
                                <tr key={i}>
                                    <td style={{ padding: '4px 8px', textAlign: 'left' }}>
                                        <span style={keyStyle}>{r.key}</span>
                                    </td>
                                    <td style={{ padding: '4px 8px', textAlign: 'left', fontSize: '0.9em' }}>
                                        {r.desc}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <button className="button_b" onClick={onClose} style={{ marginTop: '8px' }}>
                        {t('Close')}
                    </button>
                </div>
            </div>
        </Draggable>
    );
};

export default ShortcutsPopup;
